import { FormShowTemplate, FormFieldsData } from 'framework/form';
import PlanningRowItem from './PlanningRowItem';
import React from 'react';
import useProjectCycleService from '../../useProjectCycleService';

const PlanningWrapper = ({ cycle, data }: any) => {
  const { getPlanningValidationSchema, updatePlanning } = useProjectCycleService();

  return (
    <FormShowTemplate
      getDataFunc={() =>
        Promise.resolve({
          ...cycle?.planning,
          status: cycle?.status,
          planningDay: data?.settings?.cycleActivitySettings?.planningDay,
        })
      }
      submitFormFunc={(values: FormFieldsData) => {
        return updatePlanning(cycle.planning.cycleActivityId, {
          id: values.id,
          projectId: data?.id,
          cycleActivityId: values?.cycleActivityId,
          planningDate: values?.planningDate,
          details: values?.details,
          plannedScopeLink: values?.plannedScopeLink,
          isSkipped: values?.isSkipped,
          skipReason: values?.isSkipped ? values.skipReason : null,
        });
      }}
      getValidationSchemaFunc={getPlanningValidationSchema}
      afterSubmit={{
        message: 'You are awesome! The Planning has been successfully updated.',
      }}
    >
      <PlanningRowItem />
    </FormShowTemplate>
  );
};
export default PlanningWrapper;
